// This icon file is generated automatically.
var PtoErrorFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M29.87 26.75l-13-22.5a.99.99 0 00-.87-.5.98.98 0 00-.87.5l-13 22.5a1 1 0 00.87 1.5h26a1 1 0 00.87-1.5zM15 13c0-.14.11-.25.25-.25h1.5c.14 0 .25.11.25.25v5.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 01-.25-.25V13zm1 11a1.5 1.5 0 110-3 1.5 1.5 0 010 3z", "fill-rule": "nonzero" } }] }, "name": "pto-error", "theme": "filled" };
export default PtoErrorFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoErrorFilled.js
// module id = 3896
// module chunks = 0